export default "__VITE_ASSET__DvoeCwjq__"